import * as React from 'react';
import * as _ from 'lodash';
import { RootState } from 'store/types';
import { ImagesList, ViewImagesContainer, ViewImageSection, ViewImagesLabel, ViewImageSubtitle } from './styles';
import { Column, Row, Information } from './styles';
import { LMMediadata, LMimages } from 'features/Dealers/Listings/Images/state/types';
import { LMImagesInformationMessages } from 'features/Dealers/Listings/Images/state/types';
import ViewImage from './ViewImage';
import { shallowEqual, useSelector } from 'react-redux';

export interface ViewImagesProps {
    images: LMMediadata[]
    informationMessages: LMImagesInformationMessages[]
    coverPhotoMessage: string
    otherPhotosMessage: string
}


const ViewImages = (props: ViewImagesProps) => {
    const coverphoto = props.images.find(f => f.category == "COVER" && f.action !== "REMOVE");
    const mediaphoto = props.images.filter(f => f.category != "COVER" && f.action !== "REMOVE");
    return (

        <ViewImagesContainer>
            <ViewImageSection>
                <Column>
                    <ViewImageSubtitle>
                        {
                            "Cover Photo"
                        }
                    </ViewImageSubtitle>
                    {
                        renderMessage(props.coverPhotoMessage??"COVER")
                    }
                </Column>
                {
                    coverphoto &&
                    <ViewImagesLabel>
                        <ViewImage image={coverphoto}></ViewImage>
                    </ViewImagesLabel>
                }
            </ViewImageSection>

            <ViewImageSection>
                <Column>
                    <ViewImageSubtitle>
                        {
                            "Other photos"
                        }
                    </ViewImageSubtitle>
                    {
                        renderMessage(props.otherPhotosMessage??"OTHERS")
                    }
                </Column>
                <ImagesList>
                    {
                        mediaphoto.map(c => {
                            return (
                                <ViewImage image={c}></ViewImage>)
                        }
                        )

                    }
                </ImagesList>
            </ViewImageSection>
        </ViewImagesContainer>
    )

    function renderMessage(category: string) {
        return (
            <Information>
            {
                props.informationMessages.find((message) => { return message.category==category})?.message
            }
            </Information>
        )
    }
}

export default ViewImages